export const selectGalleryByPortfolioUser = (state) =>
  state.Galleries.get('byPortfolioId');
